import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nContext";
import ScrollToTop from "@/components/ScrollToTop";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import LegalPage from "@/pages/LegalPage";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isThankYou = pathname === "/thank_you";
  return (
    <>
      {!isThankYou && <Header />}
      {children}
      {!isThankYou && <Footer />}
      {!isThankYou && <CookieBanner />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <I18nProvider>
          <Chrome>
            <Routes>
              <Route path="/" element={<Navigate to="/ar" replace />} />
              <Route path="/ar" element={<Home />} />
              <Route path="/en" element={<Home />} />
              <Route path="/ar/privacidad" element={<LegalPage kind="privacy" />} />
              <Route path="/ar/cookies" element={<LegalPage kind="cookies" />} />
              <Route path="/ar/terminos" element={<LegalPage kind="terms" />} />
              <Route path="/en/privacy" element={<LegalPage kind="privacy" />} />
              <Route path="/en/cookies" element={<LegalPage kind="cookies" />} />
              <Route path="/en/terms" element={<LegalPage kind="terms" />} />
              <Route path="/thank_you" element={<ThankYou />} />
              <Route path="*" element={<Navigate to="/ar" replace />} />
            </Routes>
          </Chrome>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}
